import * as logData from "./LogTagData";

const viewLeadFormEvent = (type, obj, requestType, productName, dealDetail) => {
    let data;
    if (type === 'FIXED') {
        data = {
            page_master_tab: "business",
            page_event: "view",
            page_name: "ebu: lead form: " + "vb products",
            ebu_product_name: productName
        };
    }else{
        let type = 'upgrade';
        if(requestType === 'contract'){
            type = 'new contract';
        }
        if(obj.msisdn !== undefined && obj.msisdn !== null) {
            data = {
                page_master_tab: "business",
                page_event : "view",
                page_name : "business: deals: devices: " + type + ": lead form",
                customer_id : obj.msisdn
            };
        } else {
            data = {
                page_master_tab: "business",
                page_event : "view",
                page_name : "business: deals: devices: " + type + ": lead form",
                deal_name: dealDetail.dealShortDescription,
                price_plan: dealDetail.packageDetail.packageDescription + ' ' + dealDetail.totalMonthlySubscription,
                deal_id: dealDetail.dealId,
                service_application_name: "business: deals: devices: new contract (transaction) ",
                service_applcation_step: "business: deals: devices: new contract: lead form",
            };
        }

    }
    try {
        window.tagUtil.view(data);
    } catch (e) {
        logData.logError(e);
    }
};

const startCompletingFormEvent = (type, requestType, productName) => {
    let data;
    if (type === 'FIXED' || type === 'EMAIL') {
        data = {
            page_master_tab: "business",
            service_application_event: "start",
            service_application_name: "ebu: lead form (transaction)",
            service_application_type: "transaction",
            service_application_step: "ebu: lead form: " + productName,
            ebu_product_name: productName
        };
    }
    else {
        let type = 'upgrade';
        if(requestType === 'contract'){
            type = 'new contract';
        }
        data = {
            page_master_tab: "business",
            service_application_step : "business: deals: devices: " + type + ": lead form",
            service_application_name : "business: deals: devices: " + type + " (transaction)",
            service_application_type : "transaction",
            page_form_event : "started",
            page_form_name : "business: deals: devices: " + type + ": lead form"
        };
    }
    try {
        window.tagUtil.link(data);
    } catch (e) {
        logData.logError(e);
    }
};

const sectorCaptureFormEvent = () => {
    let data = {
        page_tool_event: "use",
        page_tool_name: "ebu: lead form: select sector tool"
    };
    try {
        window.tagUtil.view(data);
    } catch (e) {
        logData.logError(e);
    }
};
const sectorChangeEvent = (value) => {
    let data = {
        filter_query: value
    };
    try {
        window.tagUtil.view(data);
    } catch (e) {
        logData.logError(e);
    }
};

const leadSuccessEvent = (type, requestType, reference, model, price, productName, dealDetail = {}) => {
    let data = {};
    if (type.toUpperCase() === 'FIXED') {
        data = {
            page_master_tab: "business",
            page_event: "view",
            sales_event: "ebu_lead_products",
            page_name: "ebu: lead form: " + "vb products" + ": success",
            service_application_step: "ebu: lead form: " + productName + ": success",
            service_application_event: "finish",
            service_application_name: "ebu: lead form (transaction)",
            service_application_type: "transaction",
            ebu_product_name: productName
        };
    } else {
        let type = 'upgrade';
        let event = 'upgrade_lead';
        if(requestType === 'contract'){
            type = 'new contract';
            event = 'new_contract_lead';
        }
        if(type === 'upgrade'){
            data = {
                page_event : "view",
                page_name: "business: shopping: deals: devices: upgrade: lead form success",
                page_type: "checkout",
                page_channel: "shopping",
                sales_event : ["order_purchase", "ebu_upgrade_sale"],
                sales_product_category: model === 'SIM card only' ? ['sim card'] : ['devices'],
                sales_product_id: [model],
                sales_product_price: [dealDetail.totalMonthlySubscription],
                sales_product_quantity: [1],
                deal_name: dealDetail.dealShortDescription,
                price_plan: dealDetail.packageDescription + ' ' + dealDetail.totalMonthlySubscription,
                deal_accessory: "",
                deal_id: dealDetail.dealId,
                service_application_event : "finish",
                service_application_name : "business: deals: devices: " + type + " (transaction)",
                service_application_step : "business: deals: devices: " + type + ": lead success",
                lead_opportunity_number: reference
            };
        } else if (type === 'new contract'){
            data = {
                page_event : "view",
                page_error: "",
                page_name : "business: shopping: deals: devices: " + type + ": lead form success",
                page_channel: "shopping",
                page_type: "checkout",
                sales_event: ["order_purchase", "new_contract_lead"],
                sales_product_category: model === 'SIM card only' ? ['sim card'] : ['devices'],
                sales_product_id: [model],
                sales_product_price: [dealDetail.totalMonthlySubscription],
                sales_product_quantity: [1],
                deal_name: dealDetail.dealShortDescription,
                price_plan: dealDetail.packageDescription + ' ' + dealDetail.totalMonthlySubscription,
                deal_accessory: "",
                deal_id: dealDetail.dealId,
                service_application_event : "finish",
                service_application_name : "business: deals: devices: " + type + " (transaction)",
                service_application_step : "business: deals: devices: " + type + ": lead success",
                lead_opportunity_number: reference
            };
        }
        else {
            data = {
                page_master_tab: "business",
                page_event : "view",
                page_name : "business: deals: devices: " + type + ": lead form success",
                service_application_step : "business: deals: devices: " + type + ": lead form",
                service_application_event : "finish",
                service_application_name : "business: deals: devices: " + type + " (transaction)",
                service_application_type : "transaction",
                ebu_upgrade_quote : reference,
                sales_event: "purchase, " + event + "",
                sales_product_category: [type],
                sales_product_id: [model],
                sales_product_quantity: [1],
                sales_product_price: [parseFloat(price)],
                site_section : "shopping",
                page_form_event : "finish",
                page_form_name : "business: deals: devices: " + type + ": lead form success"
            };
        }

    }

    try {
        window.tagUtil.view(data);
    } catch (e) {
        logData.logError(e);
    }
};


const emailLeadSuccessEvent = (productName) => {
    let data = {};
    data = {
        page_master_tab: "business",
        page_event: "view",
        page_name: "ebu: lead form: " + "vb products" + ": success",
        service_application_step: "ebu: lead form: " + productName + ": success",
        service_application_event: "finish",
        service_application_name: "ebu: lead form (transaction)",
        service_application_type: "transaction",
        sales_event: "ebu_lead_products",
        ebu_product_name: productName
    };
    try {
        window.tagUtil.view(data);
    } catch (e) {
        logData.logError(e);
    }
};


const leadsErrorEvent = (type, err) => {
    let data = {};
    if (type.toUpperCase() === 'FIXED') {
        data = {
            page_master_tab: "business",
            page_form_event: "error",
            page_errors: err,
            page_name: "ebu: lead form: vb products: journey error"
        };
    }
    if (type.toUpperCase() === 'EMAIL') {
        data = {
            page_master_tab: "business",
            page_form_event: "error",
            page_errors: err,
            page_name: "ebu: lead form: vb products: journey error"
        };
    }
    if (type.toUpperCase() === 'GSM') {
        data = {
            page_master_tab: "business",
            page_form_event: "error",
            page_errors: err,
            page_name: "ebu: lead form: vb gsm: journey error"
        };
    }

    try {
        window.tagUtil.link(data);
    } catch (e) {
        logData.logError(e);
    }
};


export {
    viewLeadFormEvent,
    startCompletingFormEvent,
    leadSuccessEvent,
    leadsErrorEvent,
    sectorCaptureFormEvent,
    sectorChangeEvent,
    emailLeadSuccessEvent
};
